import { SxProps, Theme } from '@mui/system';

const styles: Record<string, SxProps<Theme>> = {
  mobilePaper: {
    width: '90vw',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  keyTechnologyPaper: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'unset',
  },
};

export default styles;
